<template>
  <div class="debug-panel" :class="{ 'is-open': isOpen }">
    <button class="debug-toggle" @click="togglePanel">调试</button>
    <div class="debug-content">
      <h3>滚动视图调试</h3>
      <div class="control-group">
        <label>左列速度: {{ leftSpeed }}s</label>
        <input type="range" min="20" max="120" v-model="leftSpeed" @change="updateSpeed('left')">
      </div>
      <div class="control-group">
        <label>中列速度: {{ middleSpeed }}s</label>
        <input type="range" min="20" max="120" v-model="middleSpeed" @change="updateSpeed('middle')">
      </div>
      <div class="control-group">
        <label>右列速度: {{ rightSpeed }}s</label>
        <input type="range" min="20" max="120" v-model="rightSpeed" @change="updateSpeed('right')">
      </div>
      <button @click="pauseAll" class="control-button">
        {{ isPaused ? '恢复滚动' : '暂停滚动' }}
      </button>
      <button @click="resetSpeeds" class="control-button">重置速度</button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'DebugPanel',
  setup() {
    const isOpen = ref(false);
    const isPaused = ref(false);
    const leftSpeed = ref(60);
    const middleSpeed = ref(70);
    const rightSpeed = ref(80);
    
    const togglePanel = () => {
      isOpen.value = !isOpen.value;
    };
    
    const updateSpeed = (column: string) => {
      const root = document.documentElement;
      
      if (column === 'left') {
        root.style.setProperty('--left-scroll-speed', `${leftSpeed.value}s`);
      } else if (column === 'middle') {
        root.style.setProperty('--middle-scroll-speed', `${middleSpeed.value}s`);
      } else if (column === 'right') {
        root.style.setProperty('--right-scroll-speed', `${rightSpeed.value}s`);
      }
    };
    
    const pauseAll = () => {
      isPaused.value = !isPaused.value;
      const columns = document.querySelectorAll('.scroll-content');
      columns.forEach(col => {
        (col as HTMLElement).style.animationPlayState = isPaused.value ? 'paused' : 'running';
      });
    };
    
    const resetSpeeds = () => {
      leftSpeed.value = 60;
      middleSpeed.value = 70;
      rightSpeed.value = 80;
      updateSpeed('left');
      updateSpeed('middle');
      updateSpeed('right');
    };
    
    // 初始化CSS变量
    const initCssVars = () => {
      const root = document.documentElement;
      root.style.setProperty('--left-scroll-speed', `${leftSpeed.value}s`);
      root.style.setProperty('--middle-scroll-speed', `${middleSpeed.value}s`);
      root.style.setProperty('--right-scroll-speed', `${rightSpeed.value}s`);
    };
    
    // 组件挂载时初始化
    setTimeout(initCssVars, 100);
    
    return {
      isOpen,
      isPaused,
      leftSpeed,
      middleSpeed,
      rightSpeed,
      togglePanel,
      updateSpeed,
      pauseAll,
      resetSpeeds
    };
  }
});
</script>

<style scoped>
.debug-panel {
  position: fixed;
  right: 10px;
  top: 10px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 10px;
  z-index: 1000;
  max-width: 250px;
  transform: translateX(calc(100% - 50px));
  transition: transform 0.3s ease;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
}

.debug-panel.is-open {
  transform: translateX(0);
}

.debug-toggle {
  position: absolute;
  left: 0;
  top: 10px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 5px 0 0 5px;
  padding: 8px 12px;
  cursor: pointer;
}

.debug-content {
  margin-left: 40px;
  color: white;
}

.debug-content h3 {
  margin: 0 0 10px;
  font-size: 16px;
}

.control-group {
  margin-bottom: 10px;
}

.control-group label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
}

.control-group input {
  width: 100%;
}

.control-button {
  display: block;
  width: 100%;
  padding: 8px 0;
  margin-top: 10px;
  background-color: #444;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.control-button:hover {
  background-color: #555;
}
</style>
